module.exports = __webpack_public_path__ + "img/direction_uturn.c2b5bf5e.jpg";